import React from "react";
import { connect } from "react-redux";

import { Route, Redirect } from "react-router-dom";

const RouteWrapper = ({ user, ...props }) => {
    let { path } = props;

    if (
        user?.roles.length === 1 &&
        user?.roles?.includes("token_provider") &&
        !["/signout", "/social-tokens", "/", "/profile", "/support", "/social-tokens/oauth-callback"].includes(path)
    ) {
        return <Redirect to="/social-tokens" />;
    }

    return <Route {...props} />;
};

const mapStateToProps = (state) => ({
    user: state.globalReducer.user,
});

export default connect(mapStateToProps)(RouteWrapper);
